module.exports = __webpack_public_path__ + "media/images/story/top/a-d260233b5a12bd6733c6de7d9fed5217.svg";